import React, {useState, useEffect} from 'react';
import {Card, DraftCard} from '.';
import {DateContext} from 'components';
import {flow, useDrop, useNamedSelector, usePopups, overEvery, partialRight, isEmpty} from 'helpers';
import {drop, makeDraft} from 'store/calendar';
import css from './today.module.scss';

export function CalendarDay({ date, card }) {
  const activities = useNamedSelector('calendar.dayTimetable', {
    date,
    filter: overEvery(
      useNamedSelector('settings.shareStatusFilter', {context: 'activities'}),
      useNamedSelector('activities.externalCalendarsFilter')
    )
  });

  const hasPopupOpen = !isEmpty(usePopups());
  const [ locked, setLock ] = useState();
  const [ draft, setDraft ] = useState();

  useEffect(() => {
    if (hasPopupOpen || draft) {
      setLock(true);
    } else if (!hasPopupOpen && !draft) {
      const timer = setTimeout(() => setLock(false), 200);
      return () => clearTimeout(timer);
    }
  }, [ hasPopupOpen, draft ]);

  return (
    <li className={css.column} {...useDrop(partialRight(drop, date), ({type}) => type.match(/activity/))}>
      <DateContext.Provider value={date}>
        <div className={css('cards', { locked })} onClick={locked ? undefined : flow(makeDraft, setDraft)}>
          { activities.map(activity =>
            <Card key={activity.id} {...activity} {...card} />
          ) }
          { draft &&
            <DraftCard {...draft} date={date} reset={() => setDraft(null)} />
          }
        </div>
      </DateContext.Provider>
    </li>
  );
}
